import { AxiosMethod } from "../entities/Environment";
import request from "../axios/axios";
import { OperationalLanguageInterface } from "../entities/Language";

export enum LanguageEndpoints {
  PUBLIC_TRANSLATIONS = "translations/public",
  PUBLIC_OPERATIONAL_LANGUAGE = "operational-language/public",
}

export class LanguageService {
  static getOperationalLanguages(): Promise<OperationalLanguageInterface[]> {
    return request({
      url: LanguageEndpoints.PUBLIC_OPERATIONAL_LANGUAGE,
      method: AxiosMethod.GET,
    });
  }
}
